import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false, requireSettings = false }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-slate-500 font-heading">Caricamento…</div>
      </div>
    );
  }

  if (!user) {
    // Iter 136: dopo il login si torna alla pagina richiesta (es. /da-vidimare dal link email)
    const wanted = location.pathname + location.search;
    const to = wanted && wanted !== "/" && wanted !== "/home" ? `/login?next=${encodeURIComponent(wanted)}` : "/login";
    return <Navigate to={to} replace />;
  }
  if (requireAdmin && user.role !== "admin") return <Navigate to="/" replace />;
  if (requireSettings && user.can_manage_settings === false) return <Navigate to="/" replace />;

  return children;
}
